import ProfileInfo from 'app/main/profile/ProfileInfo'
import { Routes } from 'app/services/routeService/routeService'
import { AccessType } from 'app/auth/accessControlService'
import ProfileV4 from './ProfileV4'

export default {
  settings: {
    layout: {
      config: {
        navbar: {
          display: true,
        },
        toolbar: {
          display: true,
        },
        leftSidePanel: {
          display: true,
        },
      },
    },
  },
  routes: [
    {
      path: Routes.profileInfo(),
      component: ProfileInfo,
      accesses: [AccessType.ADMINISTRATION],
    },
    {
      path: Routes.profileInfoV4(),
      component: ProfileV4,
      accesses: [AccessType.ADMINISTRATION],
    },
  ],
}
